module.exports = __webpack_public_path__ + "static/media/mwdseal.9ec09007.jpeg";